import { render } from "./NumberSection.vue?vue&type=template&id=4b997e1c&scoped=true"
import script from "./NumberSection.vue?vue&type=script&lang=js"
export * from "./NumberSection.vue?vue&type=script&lang=js"

import "./NumberSection.vue?vue&type=style&index=0&id=4b997e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b997e1c"]])

export default __exports__